import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CART_FEATURE, CustomCartState, StateWithCustomCart } from '../cart-state';

export const getCustomCartState: MemoizedSelector<StateWithCustomCart, CustomCartState> =
  createFeatureSelector<CustomCartState>(CART_FEATURE);
